export const GET_ITEMS = "GET_ITEMS";
export const GET_URL = "GET_URL";
export const GET_ONE_ITEM = "GET_ONE_ITEM";
export const GET_FIND_ITEMS = "GET_FIND_ITEMS"
export const SET_IS_LOADING_CARDS = "SET_IS_LOADING_CARDS";
export const SET_CATEGORIES = "SET_CATEGORIES"; 
export const RESER_CATEGORIES = "RESER_CATEGORIES";